import { render, staticRenderFns } from "./PriceInput.vue?vue&type=template&id=9c610c04&scoped=true"
import script from "./PriceInput.vue?vue&type=script&lang=js"
export * from "./PriceInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c610c04",
  null
  
)

export default component.exports